import Link from 'components/common/Link/Link';
import { HELP_ROUTE } from 'components/help/constants';
import * as K from 'common/constants';
import ELEMENT from 'common/element';

import './OverviewFooter.scss';

function OverviewFooter(): JSX.Element {
  return (
    <div className="OverviewFooter">
      {'Want more? Follow the instructions on how to '}
      <Link href={HELP_ROUTE.HELP_INSTALL_AGENT_LINUX_QUICK_START_1} openInNewTab testId={ELEMENT.overviewAddMoreHosts}>
        add more hosts
      </Link>
      {' or '}
      <Link href={HELP_ROUTE.SOLUTIONS_UPLOAD_MULTIPLE_LOGS} openInNewTab testId={ELEMENT.overviewAddMoreLogs}>
        add more logs
      </Link>
      {' and make ' + K.PRODUCT_NAME + ' even more useful for your service.'}
    </div>
  );
}

export default OverviewFooter;
